import {useContext} from 'react'
import { loginDispatch } from '../App'
function useLoginDispatch() {
    return useContext(loginDispatch)
}

export {useLoginDispatch}
